module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": _vm.catColor,
      "heading": 'Add ' + (_vm.localCat ? _vm.localCat : 'Organisation'),
      "size": "medium",
      "button-icon": "fa fa-plus",
      "centerButton": true,
      "showText": _vm.showText,
      "buttonText": _vm.localCat ? _vm.localCat : 'Add',
      "disableButton": _vm.disabled
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [(_vm.localCat) ? _c('div', {
    staticStyle: {
      "clear": "both",
      "text-align": "left"
    }
  }, [_c('el-form', {
    ref: "orgForm",
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.form.category + ' Name'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Name"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "e.g. Axis International Ltd can be shortened to AXIS",
      "placement": "right",
      "hide-after": 4800
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Short Name"
    },
    model: {
      value: (_vm.form.shortName),
      callback: function($$v) {
        _vm.$set(_vm.form, "shortName", $$v)
      },
      expression: "form.shortName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Registration No"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Registration No."
    },
    model: {
      value: (_vm.form.registrationNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "registrationNo", $$v)
      },
      expression: "form.registrationNo"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-id-badge"
  })])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Web Site"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Web Site"
    },
    model: {
      value: (_vm.form.website),
      callback: function($$v) {
        _vm.$set(_vm.form, "website", $$v)
      },
      expression: "form.website"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Address"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 2)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Post Code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Post Code"
    },
    model: {
      value: (_vm.form.postCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "postCode", $$v)
      },
      expression: "form.postCode"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-barcode"
  })])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "phone",
      "placeholder": "Phone"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "E-Mail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "E-Mail"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 2)], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Bank Details")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Beneficiary Name #1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Beneifciary Name"
    },
    model: {
      value: (_vm.form.beneficiaryName1),
      callback: function($$v) {
        _vm.$set(_vm.form, "beneficiaryName1", $$v)
      },
      expression: "form.beneficiaryName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name #1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bank Name"
    },
    model: {
      value: (_vm.form.bankName1),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName1", $$v)
      },
      expression: "form.bankName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Account #1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Account No."
    },
    model: {
      value: (_vm.form.bankAccount1),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccount1", $$v)
      },
      expression: "form.bankAccount1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Beneficiary Name #2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Beneifciary Name"
    },
    model: {
      value: (_vm.form.beneficiaryName2),
      callback: function($$v) {
        _vm.$set(_vm.form, "beneficiaryName2", $$v)
      },
      expression: "form.beneficiaryName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name #2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bank Name"
    },
    model: {
      value: (_vm.form.bankName2),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName2", $$v)
      },
      expression: "form.bankName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Account #2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Account No."
    },
    model: {
      value: (_vm.form.bankAccount2),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccount2", $$v)
      },
      expression: "form.bankAccount2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Beneficiary Name #3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Beneifciary Name"
    },
    model: {
      value: (_vm.form.beneficiaryName3),
      callback: function($$v) {
        _vm.$set(_vm.form, "beneficiaryName3", $$v)
      },
      expression: "form.beneficiaryName3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name #3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bank Name"
    },
    model: {
      value: (_vm.form.bankName3),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName3", $$v)
      },
      expression: "form.bankName3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Account #3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Account No."
    },
    model: {
      value: (_vm.form.bankAccount3),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccount3", $$v)
      },
      expression: "form.bankAccount3"
    }
  })], 1)], 1)], 1)], 1)], 1) : _c('div', [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Category Must Be Provided",
      "description": "A category must be provided to create and organisation.",
      "show-icon": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167be62f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/OrgAction.vue
// module id = 1437
// module chunks = 0